var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_15154)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7066 10.7063C8.5191 10.8935 8.26493 10.9987 7.99993 10.9987C7.73493 10.9987 7.48077 10.8935 7.29327 10.7063L3.52127 6.9356C3.33376 6.748 3.22845 6.4936 3.22852 6.22836C3.22858 5.96313 3.334 5.70878 3.5216 5.52127C3.7092 5.33376 3.9636 5.22845 4.22884 5.22852C4.49407 5.22858 4.74843 5.334 4.93593 5.5216L7.99993 8.5856L11.0639 5.5216C11.2524 5.33935 11.505 5.23844 11.7672 5.24059C12.0294 5.24274 12.2803 5.34779 12.4658 5.53312C12.6513 5.71844 12.7565 5.9692 12.7589 6.2314C12.7613 6.4936 12.6607 6.74625 12.4786 6.93493L8.70727 10.7069L8.7066 10.7063Z",
    fill: "#314450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_15154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDown);
export default __webpack_public_path__ + "static/media/Ic_chevron--down.fbd3896d2a514ae446d281b15df34e53.svg";
export { ForwardRef as ReactComponent };